var buttonCookieBar = document.getElementsByClassName('cb-enable')[0];
// var cookieBar = document.getElementById('cookiebar');
var cookieBar = $('#modalCookiebar');
var flag_setCookieAccepted = true;

function setCookieAccepted(value, duration) {

    if (typeof duration == 'undefined' || !duration) {
        duration = 90;
    }
    if (typeof value == 'undefined' || !value) {
        value = [];
        value.push({name: '1'});
        value.push({name: '2'});
        value.push({name: '3'});
        value.push({name: '4'});
        value.push({name: '5'});
    }

    // console.log(value);

    if (value.length < 5) {
        for (var i = 1; i <= 5; i++) {
            eraseCookie('cookie_law_accepted_'+i);
        }
    }

    var valuesArray = [];
    for (var i = 0; i < value.length; i++) {
        valuesArray.push(value[i].name);
        setCookie('cookie_law_accepted_'+value[i].name.replace('cookie', ''), true, duration);
        dataLayer.push({'event': 'cookie_law_accepted_'+value[i].name.replace('cookie', '')});
        // console.log(valuesArray);
    }
    // always set cookie1 (technical cookies)
    setCookie('cookie_law_accepted_1', true, duration);

    // check cookie non accettati
    // if (value.length < 5) {
    //     if (!valuesArray.includes('2')) {
    //     }
    //     if (!valuesArray.includes('3')) {
    //     }
    //     if (!valuesArray.includes('4')) {
    //         // analytics
    //         document.cookie = '_gid' + '=; Path=/; Domain=.'+document.domain+'; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    //         document.cookie = '_ga' + '=; Path=/; Domain=.'+document.domain+'; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    //     }
    //     if (!valuesArray.includes('cookie5')) {
    //         // pixel, remarketing
    //         document.cookie = '_fbp' + '=; Path=/; Domain=.'+document.domain+'; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    //     }
    // }

    // cookieBar.style.display = 'none';
    // cookieBar.modal('hide');
    cookieBar.foundation('close');

    flag_setCookieAccepted = false;

    $('#modalCookiebarSettingOpenFixedButton').removeClass('D(n)');
}

$('#cookiebar-form').submit(function (e) {
    e.preventDefault();
    var form = $('#cookiebar-form');
    var data = form.serializeArray();
    console.log(data);
    setCookieAccepted(data, 90);
    $('#modalCookiebarSetting').foundation('close');
});

if (getCookie('cookie_law_accepted')) {
    eraseCookie('cookie_law_accepted');
}

function triggerEvent(el, type) {
    var e = document.createEvent('HTMLEvents');
    e.initEvent(type, false, true);
    el.dispatchEvent(e);
}

buttonCookieBar.addEventListener('click', function() {
    if (flag_setCookieAccepted) {
        setCookieAccepted();
    }
});